module.exports = __webpack_public_path__ + "static/media/varilla_desnivel.c9af1bf5.jpg";